import { defineStore } from 'pinia'
import { authAPI } from '../utils/api.js'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('auth_token') || null,
    user: JSON.parse(localStorage.getItem('auth_user') || 'null'),
    isAuthenticated: false
  }),

  getters: {
    isLoggedIn: (state) => !!state.token && state.isAuthenticated,
    getToken: (state) => state.token,
    getUser: (state) => state.user
  },

  actions: {
    async login(credentials) {
      try {
        const data = await authAPI.login(credentials)
        
        // Salva il token
        this.token = data.token
        this.user = data.user
        this.isAuthenticated = true
        
        // Salva nel localStorage
        localStorage.setItem('auth_token', data.token)
        localStorage.setItem('auth_user', JSON.stringify(data.user))
        
        return { success: true, data }
      } catch (error) {
        console.error('Errore durante il login:', error)
        return { success: false, error: error.message }
      }
    },

    logout() {
      this.token = null
      this.user = null
      this.isAuthenticated = false
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_user')
    },

    async checkTokenValidity() {
      if (!this.token) {
        return false
      }

      try {
        await authAPI.verify()
        this.isAuthenticated = true
        return true
      } catch (error) {
        console.error('Errore nella verifica del token:', error)
        this.logout()
        return false
      }
    },

    async initializeAuth() {
      if (this.token) {
        // Controlla se il token è scaduto
        if (this.isTokenExpired()) {
          this.logout()
          return false
        }
        
        const isValid = await this.checkTokenValidity()
        return isValid
      }
      return false
    },

    // Funzione helper per decodificare il JWT (opzionale)
    decodeToken() {
      if (!this.token) return null
      
      try {
        const base64Url = this.token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
        
        return JSON.parse(jsonPayload)
      } catch (error) {
        console.error('Errore nella decodifica del token:', error)
        return null
      }
    },

    isTokenExpired() {
      const decoded = this.decodeToken()
      if (!decoded || !decoded.exp) return true
      
      const currentTime = Date.now() / 1000
      return decoded.exp < currentTime
    }
  }
})